/*
*  Component similar to signup but intented for existing accounts
*/
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import LoadingSpinner from '../ui/LoadingSpinner';

class Register extends Component {

  landingLogin(parmValue, accountPath) {

    if (accountPath !== "appbind") {
      let callTarget = 'appbind/vendor/' + accountPath;
      const { callPartnerApi } = this.props.auth;
      callPartnerApi(callTarget, 'GET', null)
      .then(response => {
        return response.json();
      }).then(data => {
        // Setting logo for use in bumper
        localStorage.setItem("vendorLogo", data.logo);
        if (parmValue === "vendorDefault") {
          parmValue = data.defaultParmValue;
        }
      
        let appcode = accountPath + '~' + parmValue; 
        //console.log('appcode = ' + appcode);
        this.props.auth.loginFromRegister(appcode, data.accountId, data.logo);
      }).catch(err => {
        //TODO what should we do here?
      });
    } else {
      let appcode = accountPath + '~' + parmValue; 
      //appbind is used for freshbooks and is special - we don't want any branding
      this.props.auth.loginFromRegister(appcode);
    } 
  }

  regularLogin() {
    this.props.auth.login();
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller } = this.props.auth;

    const params = new URLSearchParams(this.props.location.search);

    let path = this.props.location.pathname;
    let parmValue = null;
    let accountPath = null
    if (path.indexOf('register/') !== -1) {
      //we need to support 3 use cases
      //1) https://local.appbind.com:3000/register/demo?package=mylanding
      //2) https://local.appbind.com:3000/register/demo/mylanding
      //3) https://local.appbind.com:3000/register/demo  <- uses default package in this last case
      accountPath = path.substring(path.indexOf('register/') + 9, path.length);
      if (params.get("package") != null) {
        //use case 1
        parmValue = params.get("package");
      } else {
        //package param was null.  Lets see if it part of the URL
        if (accountPath.indexOf('/') === -1) {
          //use case 3 - see what happens above
          parmValue = "vendorDefault";
        } else {
          //use case 2
          let accountPathOrig = accountPath;
          accountPath = accountPathOrig.substring(0, accountPathOrig.indexOf('/'));
          parmValue = accountPathOrig.substring(accountPathOrig.indexOf('/') + 1, accountPathOrig.length);
        }
      };
  
    }

    if (isAuthenticated() && !isAuthenticatedReseller()) { 
      return ( <Redirect to='/home' /> );
    } else if (isAuthenticated()) { 
      this.props.auth.logoutWithoutRedirect();
    } 

    if (accountPath != null) {
      //console.log(signupApp);
      this.landingLogin(parmValue, accountPath);
    } else {
      this.regularLogin();
    }

  
    return (
      <div>
        <LoadingSpinner/>
      </div>
    );
  }
}

export default Register;